import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { installDisplayFont } from './design/fonts'
import { injectTokens } from './design/tokens'
import './design/global.css'
import { App } from './App'

// Tokens and faces go in before the first render so nothing paints unstyled.
injectTokens()
installDisplayFont()

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element in index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
